/**
 * Route for `auto-action-block-mark-reject-alert-on-fraud`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AutoActionBlockMarkRejectAlertOnFraudPage } from "../features/auto-action-block-mark-reject-alert-on-fraud/AutoActionBlockMarkRejectAlertOnFraudPage";

export const autoActionBlockMarkRejectAlertOnFraudRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/auto-action-block-mark-reject-alert-on-fraud",
	component: AutoActionBlockMarkRejectAlertOnFraudPage,
});

export default autoActionBlockMarkRejectAlertOnFraudRoute;
